import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React__default, { isValidElement, Children, cloneElement } from 'react';
import { forwardRefWithAs } from '@stacks/ui-core';
import { Box } from './box/index.esm.js';
import { Flex } from './flex/index.esm.js';

var Stack = /*#__PURE__*/forwardRefWithAs(function (props, ref) {
  var isInline = props.isInline,
      as = props.as,
      children = props.children,
      align = props.align,
      justify = props.justify,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? "tight" : _props$spacing,
      shouldWrapChildren = props.shouldWrapChildren,
      divider = props.divider,
      rest = _objectWithoutPropertiesLoose(props, ["isInline", "as", "children", "align", "justify", "spacing", "shouldWrapChildren", "divider"]);

  var validChildren = Array.isArray(children) ? children.filter(isValidElement) : [];
  return /* @__PURE__ */React__default.createElement(Flex, _extends({
    align: align,
    justify: justify,
    flexDirection: isInline ? "row" : "column",
    as: as,
    ref: ref
  }, rest), validChildren != null && validChildren.length ? Children.map(validChildren, function (child, index) {
    if (!isValidElement(child)) {
      return null;
    }

    if (!Array.isArray(children)) {
      return null;
    }

    var isLastChild = validChildren.length === index + 1;
    var spacingProps = isInline ? {
      mr: isLastChild ? void 0 : spacing
    } : {
      mb: isLastChild ? void 0 : spacing
    };
    var Divider = divider ? cloneElement(divider, spacingProps) : null;

    if (shouldWrapChildren) {
      return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, /* @__PURE__ */React__default.createElement(Box, _extends({
        display: "inline-block"
      }, spacingProps), child), !isLastChild ? Divider : null);
    }

    return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, cloneElement(child, spacingProps), !isLastChild ? Divider : null);
  }) : children);
});
Stack.displayName = "Stack";

export { Stack };
//# sourceMappingURL=stack.esm.js.map
